import { columnDefs as makeColumnDefs } from '../expertiseMake/expertiseMakeColumns.tsx';
import { IndigoAppContextType } from 'app/AppContext.tsx';

export const columnDefs = (context: IndigoAppContextType) =>
    makeColumnDefs(context);
